module.exports = __webpack_public_path__ + "public/images/icon-minus.7ac43ea53453498899294229f173cd03.svg";